import { Button, Switch } from '@root/components'
import { FaCog } from 'react-icons/fa'
import {
  StyledHeader,
  StyledHeaderContainer,
  StyledHeaderText,
  SwitchWrapper
} from './InvoiceCopyDropdown.styled'
import { useTranslation } from 'react-i18next'
import { useState } from 'react'

interface Props {
  useRefNumber: boolean
  setUseRefNumber: (value: boolean | ((prev: boolean) => boolean)) => void
}

const InvoiceCopyDropdownHeader: React.FC<Props> = ({ useRefNumber, setUseRefNumber }) => {
  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState<boolean>(false)

  return (
    <StyledHeaderContainer $isOpen={isOpen}>
      <StyledHeader>
        <StyledHeaderText>{t('invoicing.form.copyInvoiceHeaderDetail')} </StyledHeaderText>
        <Button icon={<FaCog />} isSecondary onClick={() => setIsOpen(prev => !prev)}></Button>
      </StyledHeader>

      {isOpen && (
        <SwitchWrapper>
          <Switch
            id="ref-number-switch"
            height={16}
            label={t('invoicing.form.copyInvoiceReference')}
            style={{ ml: 0 }}
            checked={useRefNumber}
            onChange={() => setUseRefNumber((prev: boolean) => !prev)}
          ></Switch>
        </SwitchWrapper>
      )}
    </StyledHeaderContainer>
  )
}

export default InvoiceCopyDropdownHeader
